import { Component, OnInit } from '@angular/core';
import { HeaderService } from '@home/header/header.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalMissingFieldsComponent } from './modal-missing-fields/modal-missing-fields.component';
import { MissingFieldService } from './modal-missing-fields/missing-field.service';

@Component({
  selector: 'app-data-validation',
  templateUrl: './data-validation.component.html',
  styleUrls: ['./data-validation.component.css'],
})
export class DataValidationComponent implements OnInit {
  showLoader = false;
  constructor(
    private headerService: HeaderService,
    private dialog: MatDialog,
    private missingFieldService: MissingFieldService
  ) {}

  ngOnInit() {
    this.headerService.showMenu(false);
    this.showLoader = true;
    this.missingFieldService.getMissingFields().subscribe(
      (response) => {
        this.showLoader = false;
        if (null != response && response.length > 0) {
          this.dialog.open(ModalMissingFieldsComponent, {
            data: response,
            disableClose: true,
            autoFocus: true,
          });
        }
      },
      (error) => {
        this.showLoader = false;
      }
    );
  }
}
